// extracted by mini-css-extract-plugin
module.exports = {"trigger":"styles_trigger__a0b7H"};